import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-role-users',
  templateUrl: './role-users.component.html',
  styleUrls: ['./role-users.component.css']
})
export class RoleUsersComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
